import VideoPlayer from '@/components/VideoPlayer';
import { PreviewAnswerPopover } from './PreviewAnswerPopover';

interface VideoRecord {
  src?: string | null;
  width: number;
  poster?: string | null;
}

export default function VideoReplay({ src, width, poster }: VideoRecord) {
  return (
    <VideoPlayer
      src={src ?? ''}
      width={width + 'px'}
      style={{
        position: 'relative',
        zIndex: 10,
        overflow: 'unset',
        // Own the box height instead of inheriting it from the parent's
        // `items-center` line: the wrapper used to be a CSS grid (Row =
        // styled(Grid), whose flexCenter sets align-items: initial =
        // stretch) and the replay relied on that stretch. Under flex +
        // items-center the height falls back to aspect-ratio + a 133%
        // padding-top hack, which collapses on iOS — the recorded answer
        // renders with no poster and no way to play it before submit.
        // Scoped to this item so the record branch keeps its centring.
        alignSelf: 'stretch'
      }}
      type="video/mp4"
      autoPlay={false}
      // Real poster captured from the live preview at record start.
      poster={poster}
      PlayIcon={<PreviewAnswerPopover />}
      ReplayIcon={<PreviewAnswerPopover />}
    ></VideoPlayer>
  );
}
